import CheckIcon from '../svg/CheckIcon';

export default function SuccessMessage({
  title,
  description,
  buttonText,
  onClick,
}) {
  return (
    <div className="space-y-4">
      <div className="text-center space-y-2">
        <div className="flex items-center justify-center">
          <div className="w-10 h-10 bg-[#D1FADF] rounded-full flex items-center justify-center">
            <CheckIcon />
          </div>
        </div>
        <p className="font-[poppins] text-xl text-[#333333] font-semibold leading-[20px]">
          {title}
        </p>
        <div>
          {description.map((text, idx) => (
            <p
              key={idx}
              className="font-[poppins] text-sm text-[#717680] font-normal leading-[22px]"
            >
              {text}
            </p>
          ))}
        </div>
      </div>
      <button
        onClick={onClick}
        className="w-full py-2 bg-[#092F7B] font-[poppins] text-sm text-[#FDFDFD] font-medium leading-[22px] text-center rounded-[10px] cursor-pointer"
      >
        {buttonText}
      </button>
    </div>
  );
}
